const CHUNK_RELOAD_SESSION_KEY = 'leo_chunk_reload_attempted';

const CHUNK_LOAD_ERROR_PATTERNS = [
  'Failed to fetch dynamically imported module',
  'Importing a module script failed',
  'Loading chunk',
];

const isChunkLoadError = (error: unknown): error is Error => {
  if (!(error instanceof Error)) {
    return false;
  }

  if (error.name === 'ChunkLoadError') {
    return true;
  }

  return CHUNK_LOAD_ERROR_PATTERNS.some((pattern) =>
    error.message.includes(pattern),
  );
};

const reloadCurrentPageWithCacheBust = () => {
  const url = new URL(window.location.href);
  url.searchParams.set('__chunk_reload', `${Date.now()}`);
  window.location.replace(url.toString());
};

const shouldReloadForChunkError = () => {
  const hasAttemptedReload =
    window.sessionStorage.getItem(CHUNK_RELOAD_SESSION_KEY) === 'true';

  if (hasAttemptedReload) {
    window.sessionStorage.removeItem(CHUNK_RELOAD_SESSION_KEY);
    return false;
  }

  window.sessionStorage.setItem(CHUNK_RELOAD_SESSION_KEY, 'true');
  return true;
};

export const lazyImportWithRetry = async <
  TModule extends { default: unknown },
>(
  importer: () => Promise<TModule>,
): Promise<TModule> => {
  try {
    const module = await importer();

    if (typeof window !== 'undefined') {
      window.sessionStorage.removeItem(CHUNK_RELOAD_SESSION_KEY);
    }

    return module;
  } catch (error) {
    if (
      typeof window !== 'undefined' &&
      isChunkLoadError(error) &&
      shouldReloadForChunkError()
    ) {
      reloadCurrentPageWithCacheBust();
      return new Promise(() => {
        // Keep suspense pending while navigation happens.
      });
    }

    throw error;
  }
};
